import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { openClose } from '@core/animations/animations';
import {
	MatterStatementOfAccount,
	StatementOfAccountDefaultTypes,
	StatementOfAccountType,
} from '@models/statementOfAccount';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { StatementOfAccountsDispatch } from '@state/matter/statementOfAccounts';
import { cloneDeep } from 'lodash';
import { UrlService } from 'src/app/shared/services/url/url.service';
import { SelectedMatter } from '@state/matter/matter.selectors';

export interface MatterStatementOfAccountEditDocumentModalData {
	statement: MatterStatementOfAccount;
}

@Component({
	selector: 'app-edit-document-text',
	templateUrl: './edit-document-text.component.html',
	styleUrls: ['./edit-document-text.component.scss'],
	animations: [openClose()],
	standalone: false,
})
export class MatterStatementOfAccountsEditDocumentTextComponent
	implements OnInit
{
	public statement: MatterStatementOfAccount;
	public StatementOfAccountType = StatementOfAccountType;
	public submitted = false;
	public viewUrl: string;

	@ViewSelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(
		public dialogRef: MatDialogRef<MatterStatementOfAccountsEditDocumentTextComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: MatterStatementOfAccountEditDocumentModalData,
		private statementOfAccountDispatch: StatementOfAccountsDispatch,
	) {}

	ngOnInit(): void {
		this.statement = cloneDeep(this.data?.statement);
		if (
			this.statement.defaultType ===
				StatementOfAccountDefaultTypes.TITLE_INSURANCE_PREMIUM ||
			this.statement.defaultType ===
				StatementOfAccountDefaultTypes.TITLE_INSURANCE_CREDIT
		) {
			this.viewUrl = UrlService.Matter_TitleInsurance(this.matterId);
		}
	}

	cancel() {
		this.dialogRef.close();
	}

	save(form: NgForm) {
		this.submitted = true;
		if (form.valid) {
			this.statementOfAccountDispatch.SetStatement(
				this.statement.id,
				this.statement,
			);
			this.dialogRef.close();
		}
	}

	setDocumentHtmlText(text): void {
		this.statement.documentHtmlText = text;
	}
}
